import classNames from 'classnames';
import { ComponentProps, useEffect, useRef } from 'react';

type PopUpProps = {
  show: boolean;
  onClose: () => void;
  duration?: number;
  color?: 'secondary' | 'error' | 'success' | 'primary';
} & ComponentProps<'div'>;

export const PopUpAlert = ({
  children,
  show,
  onClose,
  duration = 4_000,
  color = 'primary',
  className,
  ...props
}: PopUpProps) => {
  const closeRef = useRef(onClose);

  useEffect(() => {
    closeRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!show) {
      return;
    }
    const timer = setTimeout(() => {
      closeRef.current?.();
    }, duration);
    return () => clearTimeout(timer);
  }, [show, duration]);

  if (!show) {
    return null;
  }

  return (
    <div
      className={classNames('pop-up show', className, {
        'pop-up-secondary': color === 'secondary',
        'pop-up-danger': color === 'error',
        'pop-up-success': color === 'success',
        'pop-up-primary': color === 'primary',
      })}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      {...props}
    >
      {children}
    </div>
  );
};
